import { computed }                from 'mobx';
import InterventionPrivateApiModel from '../../abstracts/InterventionPrivateApiModel';

export default class OperationTypeModel extends InterventionPrivateApiModel {

	static get path(): string {
		return '/operation_types/{?id}';
	}

	@computed
	public get operationCategoryId(): number {
		return this.get('operationCategory.id', '');
	}

	@computed
	public get operationCategoryIri(): string {
		return this.get('operationCategory.@id', '');
	}
}
